module.exports = __webpack_public_path__ + "img/3.2c0231c2.png";